import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import CheckIcon from '../../icons/CheckIcon';

import { getLangValue, getPhotoThumb } from '../../../utils/Generic';

const renderHeader = (context) => (
  <div className="RoomKeySellingPointsTitle">
    {context.t('Congratulations! Good choice!')}<br />
    {context.t('You are about to book a room')}
  </div>
);

const SellingPointsBlock = (props, context) => {
  const {
    room, lang, max, flat,
  } = props;
  const sellingPoints = max ? room.key_selling_points.filter((item, index) => index < max) : room.key_selling_points;
  const hasSellingPoints = room.key_selling_points.length > 0;

  if (!hasSellingPoints) {
    return null;
  }
  return (
    <Fragment>
      {!flat && renderHeader(context)}
      <div className="RoomKeySellingPoints">
        <div className="RoomHeader">
          {room.photos.length > 0 && getPhotoThumb({ url: room.photos[0].url, width: 80 })}
          <div className="RoomHeader__name">
            {getLangValue(room, lang, 'name').toLowerCase()}
          </div>
        </div>
        <p className="includesTitle">{context.t('Which includes among other amenities and services:')}</p>
        <ul className="keypoints">
          {sellingPoints.map((sellingPoint, index) => (
            <li className="keypoints__item" key={`keypoint_${index}`}>
              {getLangValue(sellingPoint, lang, 'text')}
              <CheckIcon />
            </li>))}
        </ul>
      </div>
    </Fragment>
  );
};

SellingPointsBlock.propTypes = {
  room: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  max: PropTypes.number,
  flat: PropTypes.bool,
};

SellingPointsBlock.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default SellingPointsBlock;
